export const REGEX = /[^A-Z ]/gi

export const REGEX_NAME = /[^A-Z -]/gi

export const REGEX_EMAIL = /[^A-Z0-9@._]/gi

export const REGEX_EMAIL_NUMBER = /[^A-Z0-9-]/gi

export const REGEX_EMAIL_NUMBER_RU = /[^A-ZА-Я0-9-]/gi

export const REGEX_LATIN = /[^A-Za-zА-Яа-яЁё0-9]/gi

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const NAME_CHECK_REGEX =
  /^(?!.*([BCDFGHJKLMNPQRSTVWXYZ]{5}))(?!.*([A-Z])\2{3})[A-Z -]+$/gi

export const SERIAL_DOCUMENT = /^[A-Z]{1,3}\d{5,9}$/gi

export const PHONE_NUMBER = /[^0-9]/gi

export const NON_DIGITS_REGEX = /\D/g

export const REGEX_GRADIENT = /#[0-9A-Fa-f]{6}/g
